import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";

export const aceptarDeposito = async (deposito, realizador) => {


    deposito.fechaRespuesta = new Date().getTime()
    deposito.realizador = realizador
    let dox = await guardarDoc('depositos', deposito)
    if (dox.res) {

        let obj = {
            fechaRespuesta: deposito.fechaRespuesta,
            estado: "Aceptado",
            detalle: deposito.detalle,
            realizador: realizador,
            visible: 'Visible'
        }

        await actualizarDoc('movimientos', deposito.idMovimiento, obj)
    }


}